var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import * as React from 'react';
import { authRoles } from '../auth/auth';
import { Redirect } from 'react-router-dom';
import Utils from '../theme/utils';
import { Embed } from 'src/components/routes/embed';
import Loader from '../components/reusable/Loader';
var routeConfigs = [
    {
        settings: {
            layout: {
                config: {
                    navbar: {
                        display: false,
                    },
                    toolbar: {
                        display: false,
                    },
                    footer: {
                        display: false,
                    },
                },
            },
        },
        auth: authRoles.isLoggedOut,
        routes: [
            {
                path: '/login',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        settings: {
            layout: {
                config: {
                    navbar: {
                        display: false,
                    },
                    toolbar: {
                        display: false,
                    },
                    footer: {
                        display: false,
                    },
                },
            },
        },
        auth: authRoles.isLoggedOut,
        routes: [
            {
                path: '/auto-login',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        settings: {
            layout: {
                config: {
                    navbar: {
                        display: false,
                    },
                    toolbar: {
                        display: false,
                    },
                    footer: {
                        display: false,
                    },
                },
            },
        },
        auth: authRoles.isLoggedOut,
        routes: [
            {
                path: '/login-lp',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        settings: {
            layout: {
                config: {
                    navbar: {
                        display: false,
                    },
                    toolbar: {
                        display: false,
                    },
                    footer: {
                        display: false,
                    },
                },
            },
        },
        auth: authRoles.isLoggedOut,
        routes: [
            {
                path: '/register',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        settings: {
            layout: {
                config: {
                    navbar: {
                        display: false,
                    },
                    toolbar: {
                        display: false,
                    },
                    footer: {
                        display: false,
                    },
                },
            },
        },
        auth: authRoles.isLoggedOut,
        routes: [
            {
                path: '/reset-password',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        settings: {
            layout: {
                config: {
                    navbar: {
                        display: false,
                    },
                    toolbar: {
                        display: false,
                    },
                    footer: {
                        display: false,
                    },
                },
            },
        },
        auth: authRoles.isLoggedOut,
        routes: [
            {
                path: '/forgot-password',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        settings: {
            layout: {
                config: {
                    navbar: {
                        display: false,
                    },
                    toolbar: {
                        display: false,
                    },
                    footer: {
                        display: false,
                    },
                },
            },
        },
        auth: authRoles.isLoggedOut,
        routes: [
            {
                path: '/lp',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/home',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/support/chat',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/channel/create',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/channel/edit/:channelId',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/channel/:channelId/event-log',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/edit/video/:videoId/:version/:section/event-log',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/channel/access-control/:channelId',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/channel/recommendation/:channelId',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    // {
    //   auth: authRoles.isLoggedIn,
    //   routes: [
    //     {
    //       path: '/channel/users/:channelId',
    //       component: (props: any) => <Loader {...props} />,
    //     },
    //   ],
    // },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/channel/:channelId/home',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/channel/:channelId/videos',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/channel/:channelId/users',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/channel/:channelId/tracks',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/channel/:channelId/playlists',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/channel/:channelId/tasks',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/channel/:channelId/reports/shared',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/channel/:channelId/reports',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/channel/:channelId/playlist/:trackId/share',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    // {
    //   auth: authRoles.isAdmin,
    //   routes: [
    //     {
    //       path: '/channel/:channelId/promotions',
    //       component: (props: any) => <Loader {...props} />,
    //     },
    //   ],
    // },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/channel/:redirectId',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/track/create',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/playlist/create/:trackId',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/playlist/create',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/track/edit/:trackId',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/playlist/edit/:trackId/translations',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/playlist/edit/:trackId/share',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/playlist/edit/:trackId',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/track/users/:trackId',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/playlist/users/:trackId',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/video/:humanId/:version/:lang',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/video/:humanId',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/create/video',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/edit/video/overview/:videoId/:version/:section',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/edit/video/tags/:videoId/:version/:section',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/edit/video/reports/:videoId/:version/:section',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/edit/video/shared/reports/:videoId/:version/:section',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/edit/video/ask-for-review/:videoId/:version/:section',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/edit/video/embed-codes/:videoId/:version/:section',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/edit/video/editor/:videoId/:version/:section/voice-over',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/edit/video/editor/:videoId/:version/:section/upload-files',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/edit/video/editor/:videoId/:version/:section/effects',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/edit/video/editor/:videoId/:version/:section/manuscript',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/edit/video/editor/:videoId/:version/:section/quick-guide',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/edit/video/editor/:videoId/:version/:section/links',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/edit/video/translator/:videoId/:version/:section/title',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/edit/video/translator/:videoId/:version/:section/manuscript',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/edit/video/translator/:videoId/:version/:section/quick-guide',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/edit/video/translator/:videoId/:version/:section/links',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/edit/video/translator/:videoId/:version/:section/caption',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/edit/video/translator/:videoId/:version/:section/effects',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/edit/video/translator/:videoId/:version/:section/voice-annotation',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/edit/video/translator/:videoId/:version/:section/upload-files',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/admin/videos',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/admin/branding',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/admin/organization',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/admin/security',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/admin/channels',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/admin/tracks',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/admin/playlists',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isAdmin,
        routes: [
            {
                path: '/admin/tasks',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isAdmin,
        routes: [
            {
                path: '/admin/operationalTasks',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isAdmin,
        routes: [
            {
                path: '/admin/users/usage',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/admin/users',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/admin/azure-ad',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/admin/reports/shared',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/admin/reports',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/admin/tags',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    // {
    //   auth: authRoles.isAdmin,
    //   routes: [
    //     {
    //       path: '/finance/internal-users',
    //       component: (props: any) => <Loader {...props} />,
    //     },
    //   ],
    // },
    // {
    //   auth: authRoles.isAdmin,
    //   routes: [
    //     {
    //       path: '/finance/external-users',
    //       component: (props: any) => <Loader {...props} />,
    //     },
    //   ],
    // },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/admin/information-classification',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    // {
    //   auth: authRoles.isAdmin,
    //   routes: [
    //     {
    //       path: '/finance/video-rendering',
    //       component: (props: any) => <Loader {...props} />,
    //     },
    //   ],
    // },
    // {
    //   auth: authRoles.isAdmin,
    //   routes: [
    //     {
    //       path: '/finance/anonymous-plays',
    //       component: (props: any) => <Loader {...props} />,
    //     },
    //   ],
    // },
    {
        auth: authRoles.isAdmin,
        routes: [
            {
                path: '/finance/features-services',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/subscriptions',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/favorites',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/tasks',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/notifications',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/my-videos',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/sharings',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/results',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/history',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/library',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isLoggedIn,
        routes: [
            {
                path: '/mandatory',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isAdmin,
        routes: [
            {
                path: '/screen-recorder/',
                component: function () { return React.createElement(Redirect, { to: "/home" }); },
            },
        ],
    },
    {
        auth: authRoles.isAdmin,
        routes: [
            {
                path: '/orgs/usage',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isAdmin,
        routes: [
            {
                path: '/orgs/crm',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isAdmin,
        routes: [
            {
                path: '/orgs',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
    {
        auth: authRoles.isAdmin,
        routes: [
            {
                path: '/screen-recorder/recording-options',
                component: function () { return React.createElement(Redirect, { to: "/home" }); },
            },
        ],
    },
    {
        auth: authRoles.isAdmin,
        routes: [
            {
                path: '/screen-recorder/preview-recording',
                component: function () { return React.createElement(Redirect, { to: "/home" }); },
            },
        ],
    },
    {
        auth: authRoles.isAdmin,
        routes: [
            {
                path: '/screen-recorder/recording',
                component: function () { return React.createElement(Redirect, { to: "/home" }); },
            },
        ],
    },
    {
        auth: authRoles.isAdmin,
        routes: [
            {
                path: '/screen-recorder/upload-success/:videoId',
                component: function () { return React.createElement(Redirect, { to: "/home" }); },
            },
        ],
    },
    {
        settings: {
            layout: {
                config: {
                    navbar: {
                        display: false,
                    },
                    toolbar: {
                        display: false,
                    },
                    footer: {
                        display: false,
                    },
                },
            },
        },
        routes: [
            {
                path: '/embed/:key',
                component: Embed,
            },
        ],
    },
    {
        settings: {
            layout: {
                config: {
                    navbar: {
                        display: false,
                    },
                    toolbar: {
                        display: false,
                    },
                    footer: {
                        display: false,
                    },
                },
            },
        },
        routes: [
            {
                path: '/sharing/embed/:key',
                component: Embed,
            },
        ],
    },
    {
        settings: {
            layout: {
                config: {
                    navbar: {
                        display: false,
                    },
                    toolbar: {
                        display: false,
                    },
                    footer: {
                        display: false,
                    },
                },
            },
        },
        routes: [
            {
                path: '/sharing/:key',
                component: Embed,
            },
        ],
    },
    {
        settings: {
            layout: {
                config: {
                    navbar: {
                        display: false,
                    },
                    toolbar: {
                        display: false,
                    },
                    footer: {
                        display: false,
                    },
                },
            },
        },
        auth: authRoles.isLoggedOut,
        routes: [
            {
                path: '/loginembed',
                component: function (props) { return React.createElement(Loader, __assign({}, props)); },
            },
        ],
    },
];
export var routes = __spreadArray(__spreadArray([], Utils.generateRoutesFromConfigs(routeConfigs)), [
    {
        path: '/',
        auth: authRoles.isLoggedIn,
        component: function () { return React.createElement(Redirect, { to: "/home" }); },
    },
]);



//////////////////
// WEBPACK FOOTER
// ./src/fuse-configs/fuseRoutesConfig.tsx
// module id = 820
// module chunks = 81